import Vue from "vue";
import Component from "vue-class-component";

/**
 * How to use it: 
 * - Add this mixin to the page,
 * - Watch the pageWidth variable,
 * - Or send an onResize method as prop
 * 
 * reference: https://codepen.io/sandrarodgers/pen/porZbxW
 */
@Component
export default class ResizeHelper extends Vue {
  pageWidth = 0;
  widthTimeout: number | null = null;

   get cmWidth(): number {
    return this.pageWidth;
  }
  set cmWidth(val: number) {
    if (this.widthTimeout) clearTimeout(this.widthTimeout);
    this.widthTimeout = window.setTimeout(() => {
      this.pageWidth = val;
      this.onResize();
    }, 500);
  }

  resizeHandler(): void {
    this.cmWidth = window.innerWidth ?? window.outerWidth ?? window.screen.width ?? 0;
  }

  mounted(): void {
    this.pageWidth = window.innerWidth ?? window.outerWidth ?? window.screen.width ?? 0;
    window.addEventListener("resize", this.resizeHandler);
  }

  beforeDestroy(): void {
    window.removeEventListener("resize", this.resizeHandler);
  }

  onResize(): void {
    // This method can be overridden by the component that uses this mixin
  }
}
